"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorSchemeLabels = exports.colorSchemes = void 0;
exports.colorSchemes = ["system", "light", "dark"];
exports.colorSchemeLabels = {
    system: "Auto",
    light: "Hell",
    dark: "Dunkel",
    aria: "Farbschema",
};
//# sourceMappingURL=color-scheme.js.map